import type { Event, GeneralEvent } from '@vlabs/api/luna-api/model';

import { useWorkspaceEventContext } from './WorkspaceEventContext';

type SelectedWorkspaceEvent = Event | GeneralEvent;

interface UseSelectedWorkspaceEventReturn {
  event: SelectedWorkspaceEvent | null;

  selectedEventId: string | null;

  isEvent: boolean;
  isGeneralEvent: boolean;

  setSelectedEvent: (event: SelectedWorkspaceEvent) => void;
  clearSelectedEvent: () => void;
}

export function useSelectedWorkspaceEvent(): UseSelectedWorkspaceEventReturn {
  const {
    event,
    setEvent,
    clearEvent,
  } = useWorkspaceEventContext();

  const isGeneralEvent = !!event && 'event_type' in event;
  const isEvent = !!event && !isGeneralEvent;

  const selectedEventId = isGeneralEvent
    ? event.event?.event_id ?? null
    : event?.event_id ?? null;

  return {
    event,
    selectedEventId,
    isEvent,
    isGeneralEvent,
    setSelectedEvent: setEvent,
    clearSelectedEvent: clearEvent,
  };
}
